import { PropsWithChildren, JSX } from 'react';
import classNames from 'classnames';
import classes from './ModalHeader.module.scss';

interface IProps {
    className?: string;
    dataQa?: string;
}

export const ModalHeader = (props: PropsWithChildren<IProps>): JSX.Element => (
    <div data-qa={props.dataQa} className={classNames(classes.container, props.className)}>
        {props.children}
    </div>
);
